module.exports = __webpack_public_path__ + "img/30.6e32a419.svg";